module.exports = __webpack_public_path__ + "img/toolbar_home.bbd6c992.png";